import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SanitizeHtmlPipe} from './pipes/sanitize-html.pipe';
import {IGAEADMeetingsService} from './services/igaead-meetings.service';
import { IGAEADLookupService } from './services/igaead-lookup.service';
import { HighlightModule } from './directive/heighlight/highlight.module';
import { EDELGATEService } from './services/e-delegate-lookup.service';
import { MeetingDetailsComponent } from './components/meeting-details/meeting-details.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { UserCreateService } from './services/user-create.service';
import { UserProfileService } from './services/user-profile.service';
import { UserSigninService } from './services/user-signin.service';
import { DecisionDetailsComponent } from './components/decision-details/decision-details.component';
import { FilterButtonComponent } from './components/filter-buttons/filter-buttons.component';
import { VotesModalComponent } from './components/votes-modal/votes-modal.component';
import { IGovService } from './services/igov.service';
import { TooltipDirective } from './directive/tooltip/tooltip.directive';
import {TranslateModule} from '@ngx-translate/core';
import { ProposalsService } from './services/proposals.service';
import { SponsorshipModalComponent } from './components/sponsorship-modal/sponsorship-modal.component';
import { MeetingDetailsComponentI18N } from "./components/meeting-details-i18n/meeting-details-i18n.component";
import { TranslationHelpers } from "./services/translation-helpers.service";
import { DecisionDetailsI18nComponent } from "./components/decision-details-i18n/decision-details-i18n.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HighlightModule,
        MatIconModule,
        MatExpansionModule,
        TranslateModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SanitizeHtmlPipe,
        MeetingDetailsComponent,
        MeetingDetailsComponentI18N,
        SearchBarComponent,
        HighlightModule,
        DecisionDetailsComponent,
        DecisionDetailsI18nComponent,
        FilterButtonComponent,
        VotesModalComponent,
        TooltipDirective,
        SponsorshipModalComponent,
        TranslateModule
    ],
    declarations: [
        SanitizeHtmlPipe,
        MeetingDetailsComponent,
        MeetingDetailsComponentI18N,
        SearchBarComponent,
        DecisionDetailsComponent,
        DecisionDetailsI18nComponent,
        FilterButtonComponent,
        VotesModalComponent,
        SponsorshipModalComponent,
        TooltipDirective

    ],
    providers: [
        UserSigninService,
        UserProfileService,
        UserCreateService,
        IGAEADMeetingsService,
        TranslationHelpers,
        IGAEADLookupService,
        EDELGATEService,
        IGovService,
        ProposalsService
    ]
})
export class SharedModule {
}
